import type { ReactElement } from 'react';
import {
  UserPlus,
  Briefcase,
  Clock,
  FolderOpen,
  Users,
  FileText,
  UserX,
  FileEdit,
} from 'lucide-react';
import { useAuth } from '@/features/auth';
import { QuickActionCard, StatsCard } from '@/components/dashboard';

export function AgentDashboardPage(): ReactElement {
  const { user } = useAuth();

  const firstName = user?.profile?.firstName || 'User';

  // Placeholder handlers - functionality to be added later
  const handleAddCandidate = (): void => {
    // TODO: Navigate to add candidate page
  };
  const handleAddJobPosition = (): void => {
    // TODO: Navigate to add job position page
  };
  const handlePendingApprovals = (): void => {
    // TODO: Navigate to pending approvals page
  };
  const handleJobPositionsDirectory = (): void => {
    // TODO: Navigate to job positions directory
  };
  const handleCandidateDirectory = (): void => {
    // TODO: Navigate to candidate directory
  };
  const handleApplicationManagement = (): void => {
    // TODO: Navigate to application management
  };

  return (
    <div className="space-y-8 pb-24">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold" data-testid="dashboard-greeting">
          What's new, {firstName}?
        </h1>
        <p className="text-muted-foreground">Quick actions to move your recruitment forward</p>
      </div>

      {/* Quick Actions */}
      <section data-testid="quick-actions-section">
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          <QuickActionCard
            title="Add Candidate"
            description="Create a new candidate profile"
            icon={UserPlus}
            onClick={handleAddCandidate}
          />
          <QuickActionCard
            title="Add Job Position"
            description="Create a new job position"
            icon={Briefcase}
            onClick={handleAddJobPosition}
          />
          <QuickActionCard
            title="Pending Approvals"
            description="Review candidates awaiting approval"
            icon={Clock}
            onClick={handlePendingApprovals}
          />
          <QuickActionCard
            title="Job Positions Directory"
            description="Manage all job positions and openings"
            icon={FolderOpen}
            onClick={handleJobPositionsDirectory}
          />
          <QuickActionCard
            title="Candidate Directory"
            description="Browse all candidates"
            icon={Users}
            onClick={handleCandidateDirectory}
          />
          <QuickActionCard
            title="Application Management"
            description="Review and manage job applications"
            icon={FileText}
            onClick={handleApplicationManagement}
          />
        </div>
      </section>

      {/* Snapshot Stats */}
      <section data-testid="snapshot-section">
        <h2 className="text-lg font-semibold mb-4">Snapshot</h2>
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          <StatsCard title="Pending verifications" value={0} icon={Clock} />
          <StatsCard title="Not approved candidates" value={0} icon={UserX} />
          <StatsCard title="Draft candidates" value={0} icon={FileEdit} />
          <StatsCard title="Open job positions" value={0} icon={Briefcase} />
        </div>
      </section>
    </div>
  );
}
